export enum SessionReviewState {
  none = 0,
  reviewed = 1 << 1,
  faceMatched = 1 << 2,
  authenticated = 1 << 3,
}
